import type { BridgeNtState, BridgeSide } from '../../games/bridge-nt';
import { bridgeScoreComparison, bridgeScoreDelta } from '../../lib/bridge-score';
import './BridgeScoreComparison.css';

/** Use the same component in the live board, result summary and replay. */
export function BridgeScoreComparison({ state, yourSide }: { state: BridgeNtState; yourSide: BridgeSide | null }) {
  const score = bridgeScoreComparison(state, yourSide);
  const perspective = yourSide === null ? `${score.sideLabel}基準` : `自分の${score.sideLabel}`;
  const delta = bridgeScoreDelta(score.delta);
  const relation = score.relation === 'above' ? '理想より上' : score.relation === 'below' ? '理想より下' : score.relation === 'equal' ? '理想と同じ' : '差は未確定';
  return (
    <div className="bridge-score-comparison" data-testid="bridge-score-comparison" data-side={score.side} data-relation={score.relation} aria-label={`${perspective}、実績 ${score.actual ?? '不明'}、理想 ${score.dd ?? score.ddStatus}、差 ${delta}、${relation}`}>
      <span className="bridge-score-comparison-side">{score.sideLabel}{yourSide === null ? '基準' : ''}</span>
      <span className="bridge-score-comparison-value"><span>実績</span><strong data-testid="bridge-score-actual">{score.actual ?? '—'}</strong></span>
      <span className="bridge-score-comparison-value" title="同じ配牌・同じ初手リーダー、NTの最善基準"><span>理想</span><strong data-testid="bridge-score-dd">{score.dd ?? score.ddStatus}</strong></span>
      <span className="bridge-score-comparison-delta" data-testid="bridge-score-delta" aria-label={`差 ${delta}、${relation}`}>{delta}</span>
    </div>
  );
}
